import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Dashboard from '../pages/dashboard-pages/Dashboard/DashboardPage.tsx';

const DashboardWrapper = () => {
  const { user } = useAuth();
  const { site } = useParams();

  // Always show the old dashboard (preserving existing functionality)
return <Dashboard />;
};

export default DashboardWrapper;

